(() => {
  async function arrivals(source, signal) {
    const fresh = [], seeds = [], seen = new Set(), visited = new Set();
    let next = source;
    while (next) {
      const url = new URL(next, location.href);
      url.searchParams.set('view', 'bn-arrivals');
      url.searchParams.set('sort_by', 'created-descending');
      if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid arrivals page');
      visited.add(url.href);
      const response = await fetch(url.href, {signal, headers: {Accept: 'text/html'}});
      if (!response.ok) throw new Error('Arrivals unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const results = page.querySelector('[data-bn-arrivals-page]');
      if (!results) throw new Error('Arrivals markup unavailable');
      results.querySelectorAll('[data-arrival-item]').forEach(item => {
        const card = item.querySelector('[data-product-id]');
        if (!card || seen.has(card.dataset.productId)) return;
        seen.add(card.dataset.productId);
        (item.dataset.new === 'true' ? fresh : seeds).push({card, available: item.dataset.available === 'true'});
      });
      next = results.querySelector('[data-arrivals-next]')?.getAttribute('href');
    }
    return {items: fresh.length ? fresh : seeds, hasNew: fresh.length > 0};
  }
  if (!customElements.get('bn-arrivals-editorial')) customElements.define('bn-arrivals-editorial', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      arrivals(this.dataset.source, this.abort.signal).then(result => {
        if (!result.hasNew && !this.querySelector('[data-drop-model]').hidden) return;
        const featured = result.items.find(item => item.available && item.card.querySelector('img'));
        if (!featured) return;
        const image = featured.card.querySelector('img');
        const oldImage = this.querySelector('.bn-drop__image');
        const nextImage = image.cloneNode();
        nextImage.className = 'bn-drop__image';
        if (oldImage) oldImage.replaceWith(nextImage);
        else this.querySelector('.bn-drop__visual').prepend(nextImage);
        this.querySelector('[data-drop-model-title]').textContent = featured.card.querySelector('h3')?.textContent || image.alt;
        const link = this.querySelector('[data-drop-model]');
        link.href = featured.card.querySelector('a').href;
        link.hidden = false;
      }).catch(() => {});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
  if (!customElements.get('bn-arrivals-gallery')) customElements.define('bn-arrivals-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.loading = false;
      this.querySelector('[data-arrivals-retry]').addEventListener('click', () => this.load(), {signal: this.abort.signal});
      this.load();
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      const retry = this.querySelector('[data-arrivals-retry]');
      retry.hidden = true;
      try {
        const {items} = await arrivals(this.dataset.source, this.abort.signal);
        this.querySelector('[data-arrivals-grid]').replaceChildren(...items.map(item => item.card.cloneNode(true)));
        this.querySelector('[data-arrivals-empty]').hidden = items.length > 0;
      } catch (error) {
        if (error.name !== 'AbortError') retry.hidden = false;
      } finally {
        this.querySelector('[data-arrivals-status]').hidden = true;
        this.removeAttribute('aria-busy');
        this.loading = false;
      }
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
